import {ActionTypes} from '../api/constants'
import {IAction} from '../models'
import {User, newUser} from '../api/user'

export const saveUser = (user: User): IAction<User> => ({
  type: ActionTypes.SAVE_USER,
  payload: user,
})

const initState = newUser()
const reducer = (state = initState, action: IAction<User>) => {
  switch (action.type) {
    case ActionTypes.SAVE_USER:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}

export default reducer
